/** Стиль-пак «clean-white» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'clean-white',
  shape: {
    radiusCard: 8, radiusOption: 12, radiusButton: 'pill', radiusImage: 8,
    borderWidth: 1, borderTone: 'neutral-cool', selectionMode: 'border', shadow: 'none',
  },
  density: { optionHeight: 58, optionPadY: 14, optionPadX: 16, gap: 12, contentMaxWidth: 520, screenPadX: 20 },
  type: {
    headingFamily: 'sans', h1Size: 28, h1Weight: 600, h1Tracking: 0,
    qSize: 28, qWeight: 600, qTracking: 0, optionSize: 16, optionWeight: 400,
    headingAlign: 'center', overlineTransform: 'none',
  },
  chrome: { progress: 'nodes', progressLabel: 'center', counter: true, backButton: 'icon-circle', logo: 'none' },
  cta: { placement: 'none', fullWidth: true, height: 56, disabledStyle: 'grey' },
  states: { selected: 'brand-border-tint', hoverTint: true, transitionMs: 300, screenFadeMs: 300 },
  imagery: {
    optionCard: 'label-overlay-bottom', overlayTone: 'dark', frame: 'rounded',
    promptHint: 'neutral studio portrait, identical framing across the set, plain light backdrop',
  },
  // AddMile/Coursiv: счётчик в шапке, контент прижат к верху; типографика
  // пака центрирована (type.headingAlign), поэтому и колонка по центру.
  layout: { alignY: 'top', alignX: 'center', backgroundOverlay: 'scrim-full' },
  // AddMile/Coursiv: деловой минимализм — список стадий и честная цифра
  // выполнения, без украшений и без соцпруфа в момент ожидания.
  loader: {
    style: 'all-stages', showPercent: true, socialProof: 'review',
    answersSummary: false, engagementModals: true,
  },
  // AddMile/Coursiv: деловой минимализм — срочность есть, но компактная
  // (моно-таймер в шапке), скидка объявляется плоской плашкой без билетной
  // метафоры, помесячная цена, чип на рамке. Страница короткая: sticky-CTA
  // держит покупку в поле зрения, повторного блока не требуется.
  paywall: {
    timer: 'mono-header', promoTicket: 'plain', priceMode: 'per-month',
    planHighlight: 'chip-on-border', dimUnselectedPlans: false,
    stickyHeader: true, repeatPurchaseBlock: false,
  },
  // Белый минимализм: зелёный только на деньгах и гарантии, премиум —
  // бренд-цветом, второго украшающего акцента пак не вводит.
  accents: { money: 'success', premium: 'brand' },
};
